<section class="main--section">
  <div id="tools-section" class="p-base" *ngIf="grammarCheckerRoute">
    <ul class="m-0 p-0 list-none grid gap-xs">
      <li *ngFor="let tool of tools">
        <a
          class="flex gap-sm items-center text-15 font-medium"
          [ngClass]="{ 'link-active': tool.active }"
          href="#"
          (click)="redirectToTool($event, tool.link)"
        >
          <span class="mt--1 icon">
            <app-icons name="chevRightIcon"></app-icons>
          </span>

          {{ tool.name | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div
    id="editor-section"
    class="p-base flex flex-col gap-lg overflow-hidden"
    [ngClass]="{
      'editor-section-root': !grammarCheckerRoute,
      'position-relative': isUploading
    }"
  >
    <div
      class="flex justify-between items-center"
      style="
        background-color: #f1f2f7;
        margin-inline: -12px;
        margin-top: -12px;
        padding: 4px 12px;
        padding-right: 4px;
        color: #2d2d2d;
      "
    >
      <div #editorToolbar>
        <span class="has-tooltip">
          <button class="ql-bold"></button>
          <span class="tooltip-content tooltip-bottom">Bold</span>
        </span>
        <span class="has-tooltip">
          <button class="ql-italic"></button>
          <span class="tooltip-content tooltip-bottom">Italic</span>
        </span>
        <span class="has-tooltip">
          <button class="ql-underline"></button>
          <span class="tooltip-content tooltip-bottom">Underline</span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-align" value=""></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Align-Left" | translate }}
          </span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-align" value="center"></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Align-Center" | translate }}
          </span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-align" value="right"></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Align-Right" | translate }}
          </span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-list" value="bullet"></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Unordered-List" | translate }}
          </span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-list" value="ordered"></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Ordered-List" | translate }}
          </span>
        </span>
        <span class="has-tooltip hidden-sm">
          <button class="ql-blockquote"></button>
          <span class="tooltip-content tooltip-bottom">
            {{ "editor.Blockquote" | translate }}
          </span>
        </span>
      </div>
      <div class="flex items-center gap-xs">
        <div *ngIf="editorState.characters">
          <button
            class="btn-outline flex items-center bg-white has-tooltip"
            style="
              border: 1px solid #dcdde3 !important;
              font-size: 15px;
              height: 39px;
            "
            (click)="clearEditor()"
          >
            <app-icons name="clearIcon" />
            <span style="padding-top: 1px" class="mr-2 hidden-md">{{
              "editor.clear-text" | translate
            }}</span>
            <span class="tooltip-content tooltip-bottom">{{
              "editor.clear-text" | translate
            }}</span>
          </button>
        </div>
        <div
          style="
            position: relative;
            position: relative;
            border: 1px solid #dcdde3;
            background: white;
            border-radius: 0.375rem;
            color: inherit;
            padding: 1px 7px 4px 10px;
            height: 39px;
          "
          class="grid items-center switch-language-dropdown-container"
        >
          <button
            (click)="toggleReportMenu($event)"
            [disabled]="submitting"
            class="switch-language-dropdown flex items-center gap-default justify-between text-14"
          >
            <span class="flex gap-default items-center">
              <app-icons-free-tools
                *ngIf="!iconRequireReattachment"
                [name]="languages[selectedLanguage].icon"
              ></app-icons-free-tools>
              <span
                style="
                  padding-top: 1px;
                  text-wrap: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 90px;
                  text-align: left !important;
                "
                class="language-name"
                >{{ languages[selectedLanguage].name }}</span
              >
            </span>
            <app-icons name="chevronDown"></app-icons>
          </button>

          <ul
            style="display: none"
            class="language-menu p-0"
            (click)="switchLanguage($event)"
          >
            <ng-container *ngTemplateOutlet="languageList"></ng-container>
          </ul>
        </div>
      </div>
    </div>

    <div
      class="flex-1 scrollable scrollable-editor-container"
      [ngClass]="{ 'position-relative': loading }"
    >
      <div class="full" spellcheck="false" #ginEditor></div>

      <ng-container *ngTemplateOutlet="errorPopup" />

      <div
        class="position-absolute top-0 bottom-0 start-0 end-0 bg-white pt-1"
        *ngIf="loading"
      >
        <app-skeleton
          [times]="7"
          [style]="{ marginBottom: '0.75rem', height: '1.25rem' }"
        />
        <app-skeleton
          [style]="{ marginBottom: '0.75rem', height: '1.25rem', width: '35%' }"
        />
      </div>
    </div>

    <div class="flex justify-between items-center flex-col-md">
      <!-- <div class="clear-icon-container" *ngIf="editorState.characters">
        <button class="btn-outline p-0" (click)="clearEditor()">
          <app-icons name="clearIcon" />
        </button>
      </div> -->

      <div class="flex gap-default items-center file-upload-section">
        <app-upload-file
          (uploadStarted)="isUploading = true"
          (uploadFinished)="isUploading = false"
        />

        <div *ngIf="captchaVisible" class="captcha-modal-overlay">
          <div class="captcha-modal">
            <div
              id="recaptcha-container"
              class="recaptcha-container"
              data-size="compact"
              data-theme="light"
            ></div>
          </div>
        </div>

        <ul
          class="list-none flex gap-md m-0 p-0 text-14"
          *ngIf="editorState.characters"
        >
          <li>{{ "editor.Words" | translate }}: {{ f(editorState.words) }}</li>
          <li class="hidden-md">|</li>
          <li class="hidden-sm">
            {{ "editor.Characters" | translate }}:
            {{ f(editorState.characters) }}
          </li>
        </ul>
      </div>

      <div class="flex gap-default items-center check-grammar-btn-section">
        <ul
          class="list-none flex gap-md m-0 p-0 hidden-md"
          *ngIf="editorState.characters"
        >
          <!--<li><button class="btn-outline p-0" (click)="clearEditor()"><app-icons name="clearIcon" /></button></li>-->
          <li>
            <button
              class="btn-outline p-0 has-tooltip"
              (click)="copyToClipboard(quillEditor.getText())"
            >
              <app-icons name="copyIcon" />

              <span
                class="tooltip-content tooltip-top"
                id="copy-to-clipboard-tooltip"
                >{{ copyText | translate }}</span
              >
            </button>
          </li>
        </ul>
        <button
          class="check-grammar-btn"
          [ngClass]="{ 'check-grammar-btn-loading': submitting }"
          [disabled]="submitting || editorState.words === 0"
          (click)="handleCheckGrammarButton()"
        >
          {{
            (submitting ? "editor.Checking" : "editor.Check" + toolName)
              | translate
          }}
        </button>
      </div>
    </div>

    <div class="upload-spinner-container" *ngIf="isUploading">
      <h3 class="fs-6 flex items-center gap-sm">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="spin-infinite"
        >
          <path d="M21 12a9 9 0 1 1-6.219-8.56" />
        </svg>

        <span>{{ "editor.uploading" | translate }}...</span>
      </h3>
    </div>
  </div>

  <div
    id="results-section"
    class="p-base overflow-hidden flex flex-col"
    [ngClass]="{ 'suggestions-section-root': !grammarCheckerRoute }"
    *ngIf="!loading && !submitting"
  >
    <ng-container *ngIf="editorState.status.all">
      <div
        class="flex justify-between items-center text-15 font-medium"
        id="all-suggestions-container"
      >
        <div class="flex gap-xs" id="all-suggestions-count">
          <span>{{ "editor.All-Suggestions" | translate }}</span>
          <span class="count">{{ editorState.status.all }}</span>
        </div>

        <button
          id="correct-all-button"
          class="flex gap-sm"
          [attr.data-target]="'pricing-modal'"
          (click)="authState !== 'pro' ? invokeModal($event) : correctAll()"
        >
          <span class="icon">
            <app-icons name="correctAll"></app-icons>
          </span>
          <span class="text">{{ "editor.Correct-All" | translate }}</span>
        </button>
      </div>

      <div class="flex-1 scrollable">
        <ul
          class="list-none ml-0 px-0 my-3 grid gap-default mb-2"
          id="corrections-container"
          *ngIf="Object.keys(editorState.filteredErrors).length"
        >
          @for (el of Object.keys(editorState.filteredErrors); track el) { @for
          (errors of editorState.filteredErrors[el]; track errors) { @for (error
          of [errors]; track error) { @if (error.errorType === 'modAcc' ||
          error.errorType === 'modClr') { @if (!(error.errorType === 'modClr' &&
          ['guest', 'auth'].includes(authState)) || error.unlocked) {
          <li
            [attr.data-error]="'err-' + error.highlights[0].tread_id"
            (mouseenter)="highlightErrorInEditor($event, error.ColorLight)"
            (mouseleave)="removeHighlightInEditor($event)"
          >
            <button
              class="w-full expand-toggler"
              (click)="toggleErrorListExpand($event, error.ColorLight)"
            >
              <span class="flex gap-lg items-center">
                <span
                  class="pill"
                  [ngClass]="
                    error.errorType === 'modAcc' ? 'pill-danger' : 'pill-info'
                  "
                ></span>
                <span class="error-text fw-medium text-15 error-wrong">{{
                  error.highlights[0].wrong
                }}</span>
              </span>
              <span class="error-list-type text-14">
                {{ "editor.Correct" + error.highlights[0].model | translate }}
              </span>
            </button>

            <div
              class="error-card-header items-center gap-lg"
              (click)="toggleErrorListExpand($event, error.ColorLight)"
              [title]="'editor.ToggleExpanded' | translate"
            >
              <span
                class="pill"
                [ngClass]="
                  error.errorType === 'modAcc' ? 'pill-danger' : 'pill-info'
                "
              ></span>
              <span class="error-type fw-medium text-15">{{
                "editor." + error.highlights[0].model | translate
              }}</span>
            </div>

            <div class="error-text-paragraph-container">
              <p
                class="error-text-paragraph overflow-y-auto mb-1 text-14"
                [innerHTML]="formatReplacementsArray(error.replacements[0])"
              ></p>
            </div>

            <div class="error-card-footer">
              <div class="flex gap-default justify-end text-14">
                <button
                  class="flex gap-sm btn-secondary text-center text-14 dismiss-button"
                  style="
                    height: 34px;
                    width: 150px;
                    text-align: center !important;
                    font-size: 14px;
                  "
                  [attr.data-target]="'err-' + error.highlights[0].tread_id"
                  (click)="handleDismiss($event, error.errorType)"
                >
                  <span>
                    {{ "editor.Dismiss" | translate }}
                  </span>
                </button>
                <button
                  class="correction-button accept-button"
                  style="
                    height: 34px;
                    width: 150px;
                    text-align: center !important;
                    font-size: 14px;
                  "
                  [attr.data-model]="error.errorType"
                  [attr.data-target]="'err-' + error.highlights[0].tread_id"
                  [attr.data-correction]="JSON.stringify(error.replacements[0])"
                  [attr.data-correct]="error.correct"
                  (click)="handleCorrection($event)"
                >
                  {{ "editor.Accept" | translate }}
                </button>
              </div>
            </div>
          </li>
          } } @if (error.errorType === 'accuracy' || error.errorType === 'style'
          || error.errorType === 'clarity' || error.errorType === 'syntax') {
          @if ( ! ( ( ['guest', 'auth'].includes(authState) && !(['accuracy',
          'clarity'].includes(error.errorType) && error.errorType === 'accuracy'
          || error.unlocked ) ) ) ) {
          <li
            [attr.data-error]="'err-' + error.ChkiD + '-' + error.offset"
            (mouseenter)="highlightErrorInEditor($event, error.ColorLight)"
            (mouseleave)="removeHighlightInEditor($event)"
          >
            <button
              class="w-full expand-toggler"
              (click)="toggleErrorListExpand($event, error.ColorLight)"
            >
              <span class="flex gap-lg items-center">
                <span
                  class="pill"
                  [style.background-color]="error.Color"
                ></span>
                <span class="fw-medium text-15 error-wrong">{{
                  error.wrong
                }}</span>
              </span>
              <span class="error-list-type text-14">
                {{ "editor.Correct" + error.errorType | translate }}
              </span>
            </button>

            <div
              class="error-card-header items-center gap-lg"
              (click)="toggleErrorListExpand($event, error.ColorLight)"
            >
              <span class="pill" [style.background-color]="error.Color"></span>
              <span class="error-type fw-medium text-15">{{
                "editor." + error.errorType | translate
              }}</span>
            </div>

            <div class="error-text-paragraph-container mt-1">
              <div class="error-text-paragraph overflow-y-auto text-14">
                @if (error.replacements.length > 0) {
                <div class="flex gap-sm mode-error-correction">
                  <span class="error-text">{{ error.wrong }}</span>
                  <button
                    class="corrected-text"
                    [attr.data-target]="
                      'err-' + error.ChkiD + '-' + error.offset
                    "
                    (click)="handleCorrection($event)"
                    [attr.data-correction]="error.replacements[0].value"
                  >
                    {{ error.replacements[0]?.value }}
                  </button>
                </div>
                }

                <div class="my-3" *ngIf="error.replacements.length > 1">
                  <span>Suggestion(s):</span>
                  <div class="flex gap-sm my-1">
                    @for (replacement of error.replacements; track replacement)
                    {
                    <button
                      class="btn-outline px-2 py-1"
                      [attr.data-target]="
                        'err-' + error.ChkiD + '-' + error.offset
                      "
                      (click)="handleCorrection($event)"
                      [attr.data-correction]="replacement.value"
                    >
                      {{ replacement.value }}
                    </button>
                    }
                  </div>
                </div>

                <p class="pb-0 mb-0 mt-3">
                  <strong>Description: </strong>
                  <em>{{ error.message }}</em>
                </p>
              </div>
            </div>

            <div class="error-card-footer mt-2">
              <button
                class="flex gap-sm btn-secondary text-center text-14 dismiss-button"
                style="
                  height: 34px;
                  width: 150px;
                  text-align: center !important;
                  font-size: 14px;
                "
                [attr.data-target]="'err-' + error.ChkiD + '-' + error.offset"
                (click)="handleDismiss($event)"
              >
                <span>
                  {{ "editor.Dismiss" | translate }}
                </span>
              </button>
            </div>
          </li>
          } } } } } @if (['guest', 'auth'].includes(authState)) {
          <li
            class="premium-suggestion"
            id="9eymM-HtPD2M-clr"
            [attr.data-target]="'pricing-modal'"
            (click)="invokeModal($event)"
          >
            <div class="content pb-3">
              <div class="error-card-header flex items-center gap-lg pt-3 mx-3">
                <span class="pill pill-info"></span>
                <span class="error-type fw-medium text-15">
                  {{ "editor.clarity" | translate }}
                </span>
              </div>
              <div class="flex gap-sm items-center premium-content-container">
                <div class="flex gap-default items-center">
                  <img
                    src="../../../assets/images/editorimages/premium-user-animation.webp"
                    alt=""
                    width="53"
                    height="53"
                  />
                  <p class="mb-0 fw-medium">
                    {{ "editor.unlock-features" | translate }}
                  </p>
                </div>

                <div class="flex-1">
                  <button
                    (click)="invokeModal($event)"
                    [attr.data-target]="'pricing-modal'"
                    class="upgrade-pro"
                  >
                    <app-icons name="premiumDiamondIcon" />
                    <span>{{ "editor.Upgrade" | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </li>

          <li
            class="premium-suggestion"
            id="9eymM-HtPD2M-sty"
            [attr.data-target]="'pricing-modal'"
            (click)="invokeModal($event)"
          >
            <div class="content pb-3">
              <div class="error-card-header flex items-center gap-lg pt-3 mx-3">
                <span
                  class="pill"
                  style="background-color: rgb(51, 182, 108)"
                ></span>
                <span class="error-type fw-medium text-15">
                  {{ "editor.style" | translate }}
                </span>
              </div>
              <div class="flex gap-sm items-center premium-content-container">
                <div class="flex gap-default items-center">
                  <img
                    src="../../../assets/images/editorimages/premium-user-animation.webp"
                    alt=""
                    width="53"
                    height="53"
                  />
                  <p class="mb-0 fw-medium">
                    {{ "editor.unlock-features" | translate }}
                  </p>
                </div>

                <div class="flex-1">
                  <button
                    (click)="invokeModal($event)"
                    [attr.data-target]="'pricing-modal'"
                    class="upgrade-pro"
                  >
                    <app-icons name="premiumDiamondIcon" />
                    <span>
                      {{ "editor.Upgrade" | translate }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </li>

          <li
            class="premium-suggestion"
            id="9eymM-HtPD2M-syn"
            [attr.data-target]="'pricing-modal'"
            (click)="invokeModal($event)"
          >
            <div class="content pb-3">
              <div class="error-card-header flex items-center gap-lg pt-3 mx-3">
                <span class="pill" style="background-color: #f87f11"></span>
                <span class="error-type fw-medium text-15">
                  {{ "editor.syntax" | translate }}
                </span>
              </div>
              <div class="flex gap-sm items-center premium-content-container">
                <div class="flex gap-default items-center">
                  <img
                    src="../../../assets/images/editorimages/premium-user-animation.webp"
                    alt=""
                    width="53"
                    height="53"
                  />
                  <p class="mb-0 fw-medium">
                    {{ "editor.unlock-features" | translate }}
                  </p>
                </div>

                <div class="flex-1">
                  <button
                    (click)="invokeModal($event)"
                    [attr.data-target]="'pricing-modal'"
                    class="upgrade-pro"
                  >
                    <app-icons name="premiumDiamondIcon" />
                    <span>
                      {{ "editor.Upgrade" | translate }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </li>
          }
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="!editorState.status.all">
      <ng-container *ngTemplateOutlet="emptyContent"></ng-container>
    </ng-container>
  </div>

  <div
    id="results-section"
    class="p-base"
    *ngIf="loading || submitting"
    [ngClass]="{ 'suggestions-section-root': !grammarCheckerRoute }"
  >
    <div class="overflow-hidden">
      <app-errors-loader />
    </div>
  </div>

  <button
    (click)="invokeModal($event)"
    [attr.data-target]="'word-limit-exceed-modal'"
    class="word-limit-exceed d-none"
  ></button>
</section>

@if (authState !== 'pro') {
<app-modal
  parent="pricing-modal"
  [style]="{
    borderRadius: '0.75rem',
    border: '1px solid oklch(0.82 0.1471 171.99 / 25.5%)'
  }"
>
  <modal-content>
    <section>
      <div class="flex justify-between">
        <h3 class="mt-1 mb-0">Grammarin Premium</h3>

        <button (click)="dismissModal($event)" style="background: transparent">
          <app-icons name="closeModalIcon"></app-icons>
        </button>
      </div>

      <p class="fw-medium">
        {{ "editor.Upgrade-plan" | translate }}
      </p>

      <app-premium [heading]="false" />

      <div class="flex flex-col items-center mt-3">
        <a href="/pricing" target="_blank" class="upgrade-to-premium-button">
          {{ "editor.View-All" | translate }}
        </a>
      </div>
    </section>
  </modal-content>
</app-modal>
<app-modal
  parent="word-limit-exceed-modal"
  [style]="{
    borderRadius: '0.75rem',
    border: '1px solid oklch(0.82 0.1471 171.99 / 25.5%)'
  }"
>
  <modal-content>
    <section>
      <div class="flex justify-between">
        <h3 class="mt-1 mb-0">Word Limit Exceeded</h3>

        <button (click)="dismissModal($event)" style="background: transparent">
          <app-icons name="closeModalIcon"></app-icons>
        </button>
      </div>

      <p class="fw-medium">
        {{ "editor.shorten-content" | translate }}
      </p>

      <app-premium [heading]="false" />

      <div class="flex flex-col items-center mt-3">
        <a href="/pricing" target="_blank" class="upgrade-to-premium-button">
          {{ "editor.View-All" | translate }}
        </a>
      </div>
    </section>
  </modal-content>
</app-modal>
}

<ng-template #emptyContent>
  <section class="grid full place-items-center empty-content-placeholder">
    <div class="text-center">
      <img
        src="../../../assets/images/grammar checker/grammar-checker-searching.avif"
        alt=""
        class="mx-auto"
      />

      <h3 class="fs-5 mt-3">
        {{ "editor.something-great" | translate }}
      </h3>
      <p class="px-5 lh-sm mb-4">
        {{ "editor.generate-suggestions" | translate }}
      </p>

      <app-skeleton
        [times]="2"
        [style]="{ width: '180px', marginInline: 'auto' }"
      ></app-skeleton>
      <app-skeleton
        [style]="{ width: '110px', marginInline: 'auto' }"
      ></app-skeleton>
    </div>
  </section>
</ng-template>

<ng-template #errorPopup>
  <div class="error-popup" *ngIf="activeError">
    <div class="error-popup-header">
      <div
        class="flex justify-between items-center py-1"
        style="padding-inline: 0.4rem"
      >
        <div class="flex items-center gap-default">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.1896 0H4.81039C2.15369 0 0 2.14903 0 4.8V19.2C0 21.851 2.15369 24 4.81039 24H19.1896C21.8463 24 24 21.851 24 19.2V4.8C24 2.14903 21.8463 0 19.1896 0Z"
              fill="#08BA9C"
            />
            <path
              d="M8.16262 9.21292C7.96887 9.67866 7.86195 10.189 7.86195 10.7231C7.86195 11.2571 7.96262 11.7389 8.14624 12.1934C8.14879 12.1996 8.15128 12.2071 8.15383 12.2133C8.75134 13.6688 10.1966 14.697 11.8873 14.697V17.6775C11.8495 17.6775 11.8131 17.6775 11.7753 17.6763C8.45322 17.6254 5.68833 15.3044 5.00529 12.2133C5.00403 12.2071 5.00277 12.1996 5.00151 12.1934C4.89836 11.719 4.84302 11.2273 4.84302 10.7231C4.84302 10.2188 4.90088 9.69977 5.01032 9.21292C5.70845 6.09832 8.5224 3.76855 11.8873 3.76855V6.74906C11.8495 6.74906 11.8131 6.74906 11.7753 6.75027C10.1413 6.79376 8.75134 7.79967 8.16262 9.21292Z"
              fill="white"
            />
            <path
              d="M18.7699 12.1972H18.7649C18.7649 12.2035 18.7686 12.2085 18.7699 12.2147V13.916C18.7699 16.0198 17.7988 18.0316 16.0893 19.2896C16.0315 19.3319 15.9723 19.3741 15.9132 19.415C14.7723 20.2011 13.3849 20.6619 11.8879 20.6619V17.6814C11.9257 17.6814 11.9622 17.6814 11.9999 17.6802C14.171 17.6218 15.9132 15.8645 15.9132 13.7074V12.1972H11.8879V9.2168H18.7649L18.7699 9.22174V12.1972Z"
              fill="white"
            />
          </svg>

          <h3 class="error-popup-title fs-6 m-0">
            <ng-container
              *ngIf="['modAcc', 'modClr'].includes(activeError.errorType)"
            >
              {{
                "editor." +
                  (activeError.errorType === "modAcc" ? "accuracy" : "clarity")
                  | translate
              }}
            </ng-container>
            <ng-container
              *ngIf="!['modAcc', 'modClr'].includes(activeError.errorType)"
            >
              {{ "editor." + activeError.errorType | translate }}
            </ng-container>
          </h3>
        </div>

        <button
          class="p-0 bg-transparent"
          style="margin-bottom: 4px"
          (click)="activeError = null"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.05029 5.0498L14.9498 14.9493"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
            <path
              d="M14.9497 5.0498L5.05021 14.9493"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    </div>
    <div class="error-popup-body p-base text-14">
      <p
        class="mb-0"
        *ngIf="
          ['modAcc', 'modClr'].includes(activeError.errorType);
          else algoError
        "
        [innerHTML]="formatReplacementsArray(activeError.replacements[0])"
      ></p>

      <ng-template #algoError>
        <div class="mode-error-correction flex gap-sm">
          <span class="error-text">{{ activeError.wrong }}</span>
          <button
            class="corrected-text"
            [attr.data-target]="
              'err-' + activeError.ChkiD + '-' + activeError.offset
            "
            (click)="handlePseudoCorrectionOneWord($event)"
            [attr.data-correction]="activeError.replacements[0].value"
          >
            {{ activeError.replacements[0]?.value }}
          </button>
        </div>

        <p class="mt-3 mb-0">
          <em>{{ activeError.message }}</em>
        </p>
      </ng-template>
    </div>
    <div
      class="error-popup-footer p-base flex justify-between items-center mb-2"
      [ngClass]="{
        'pt-1': !['modAcc', 'modClr'].includes(activeError.errorType)
      }"
    >
      <ul
        class="flex gap-sm items-center list-unstyled m-0 p-0 text-15"
        *ngIf="
          ['modAcc', 'modClr'].includes(activeError.errorType);
          else dismissAlgo
        "
      >
        <li [attr.data-error]="'err-' + activeError.highlights[0].tread_id">
          <button
            class="correction-button accept-button"
            [attr.data-model]="activeError.errorType"
            [attr.data-target]="'err-' + activeError.highlights[0].tread_id"
            [attr.data-correction]="JSON.stringify(activeError.replacements[0])"
            [attr.data-correct]="activeError.correct"
            (click)="handlePseudoCorrection($event)"
          >
            {{ "editor.Accept" | translate }}
          </button>
        </li>
        <li [attr.data-error]="'err-' + activeError.highlights[0].tread_id">
          <button
            class="flex items-center gap-sm btn-secondary text-center dismiss-button"
            style="height: 34px; width: 150px; text-align: center !important"
            [attr.data-target]="'err-' + activeError.highlights[0].tread_id"
            (click)="handlePseudoCorrection($event, 'Dismiss')"
          >
            {{ "editor.Dismiss" | translate }}
          </button>
        </li>
      </ul>
      <ng-template #dismissAlgo>
        <ul class="flex gap-sm items-center list-unstyled m-0 p-0 text-15">
          <li
            [attr.data-error]="
              'err-' + activeError.ChkiD + '-' + activeError.offset
            "
          >
            <button
              class="flex items-center gap-sm btn-secondary text-center dismiss-button"
              style="height: 34px; width: 150px; text-align: center !important"
              [attr.data-target]="
                'err-' + activeError.ChkiD + '-' + activeError.offset
              "
              (click)="handleDismiss($event)"
            >
              <span>
                {{ "editor.Dismiss" | translate }}
              </span>
            </button>
          </li>
        </ul>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #languageList>
  <ng-container *ngFor="let language of Object.keys(languages)">
    <ng-container
      *ngIf="languages[language].name.length; else langugeSeparator"
    >
      <li [attr.data-language]="language">
        <app-icons-free-tools
          [name]="languages[language].icon"
        ></app-icons-free-tools>
        {{ languages[language].name }}
      </li>
    </ng-container>

    <ng-template #langugeSeparator>
      <li class="lang-separator"></li>
    </ng-template>
  </ng-container>
</ng-template>
